export enum RequestTypeEnum {
  CREATE = 'CREATE',
  UNASSIGN = 'UNASSIGN',
  ASSIGN = 'ASSIGN',
}
